import { fork, all } from "redux-saga/effects";

import checkTenantGetSaga from "./api/checkTenantGet/checkTenantGetSaga";
import usersMeGetSaga from "./api/usersMeGet/usersMeGetSaga";
import rootAccountGetSaga from "./api/rootAccountGet/rootAccountGetSaga";
import applicationConnectPostSaga from "./api/applicationConnectPost/applicationConnectPostSaga";
import notificationsGetSaga from "./api/notificationsGet/notificationsGetSaga";
import notificationHidePutSaga from "./api/notificationHidePut/notificationHidePutSaga";
import notificationTouchPutSaga from "./api/notificationTouchPut/notificationTouchPutSaga";
import notificationsTouchAllPutSaga from "./api/notificationsTouchAllPut/notificationsTouchAllPutSaga";
import whitelabelGetSaga from "store/whitelabel/whitelabelGetSaga";
import uiPopupsPostSaga from "store/api/uiPopupsPost/uiPopupsPostSaga";
import accountGetSaga from "store/api/organization/accountGet/accountGetSaga";
import subscriptionActivateAddonsPostSaga from "store/api/organization/subscriptionActivateAddonsPost/subscriptionActivateAddonsPostSaga";
import agentsBuildsGetSaga from "store/api/organization/agentsBuildsGet/agentsBuildsGetSaga";
import getStartedProgressGetSaga from "store/api/organization/getStartedProgressGet/getStartedProgressGetSaga";
import getStartedRefreshSaga from "store/api/organization/getStartedRefresh/getStartedRefreshSaga";
import getStartedActionSaga from "store/api/organization/getStartedAction/getStartedActionSaga";
import organizationsGetSaga from "./api/organizationsGet/organizationsGetSaga";
import networkPoliciesGetSaga from "store/api/organization/networkPoliciesGet/networkPoliciesGetSaga";
import dpcProfilesGetSaga from "store/api/organization/dpcProfilesGet/dpcProfilesGetSaga";
import applicationsSettingsGetSaga from "store/api/organization/applicationsSettingsGet/applicationsSettingsGetSaga";
// Sagas paired with the always-on reducers added to rootReducer.js for the
// Network MFE — see that file's comment for rationale.
import applicationsGetSaga from "store/api/organization/applicationsGet/applicationsGetSaga";
import networksGetSaga from "store/api/organization/networksGet/networksGetSaga";
import networksBeaconsGetSaga from "store/api/organization/networksBeaconsGet/networksBeaconsGetSaga";
import networkBeaconDeleteSaga from "store/api/organization/networkBeaconDelete/networkBeaconDeleteSaga";
import sslCertificatesGetSaga from "store/api/organization/sslCertificatesGet/sslCertificatesGetSaga";
import signedUrlPostSaga from "store/api/signedUrlPost/signedUrlPostSaga";
import webRulesSWGGetSaga from "store/api/organization/webRulesSWGGet/webRulesSWGGetSaga";
import policyInsightsConflictsGetSaga from "store/api/organization/policyInsightsConflictsGet/policyInsightsConflictsGetSaga";
import policyInsightsConflictAckPatchSaga from "store/api/organization/policyInsightsConflictAckPatch/policyInsightsConflictAckPatchSaga";
import networkCustomerCertificatesGetSaga from "store/api/organization/networkCustomerCertificatesGet/networkCustomerCertificatesGetSaga";
import cpAppEvalSKUsPostSaga from "./api/cpAppEvalSKUsPost/cpAppEvalSKUsPostSaga";
import updatableObjectsSaga from "./api/updatableObjects/updatableObjectsSaga";
import ipsecVendorsGetSaga from "./api/organization/ipsecVendorsGet/ipsecVendorsGetSaga";
import permissionCategoriesGetSaga from "./api/permissionCategoriesGet/permissionCategoriesGetSaga";
import servicesGetSaga from "./api/organization/servicesGet/servicesGetSaga";
import regionsGetSaga from "./api/regionsGet/regionsGetSaga";
// Sagas for the Security-route slices added always-on for the IA MFE.
import membersAllGetSaga from "./api/organization/membersAllGet/membersAllGetSaga";
import groupsGetSaga from "./api/organization/groupsGet/groupsGetSaga";
import webCategoriesGetSaga from "./api/organization/webCategoriesGet/webCategoriesGetSaga";
import addressesGetSaga from "./api/organization/addressesGet/addressesGetSaga";

export default function* rootSaga() {
  yield all([
    fork(checkTenantGetSaga),
    fork(usersMeGetSaga),
    fork(rootAccountGetSaga),
    fork(getStartedProgressGetSaga),
    fork(getStartedRefreshSaga),
    fork(getStartedActionSaga),
    fork(applicationConnectPostSaga),
    fork(notificationsGetSaga),
    fork(notificationHidePutSaga),
    fork(notificationTouchPutSaga),
    fork(notificationsTouchAllPutSaga),
    fork(whitelabelGetSaga),
    fork(uiPopupsPostSaga),
    fork(accountGetSaga),
    fork(subscriptionActivateAddonsPostSaga),
    fork(agentsBuildsGetSaga),
    fork(organizationsGetSaga),
    fork(networkPoliciesGetSaga),
    fork(dpcProfilesGetSaga),
    fork(applicationsSettingsGetSaga),
    fork(applicationsGetSaga),
    fork(networksGetSaga),
    fork(networksBeaconsGetSaga),
    fork(networkBeaconDeleteSaga),
    fork(sslCertificatesGetSaga),
    fork(signedUrlPostSaga),
    fork(webRulesSWGGetSaga),
    fork(policyInsightsConflictsGetSaga),
    fork(policyInsightsConflictAckPatchSaga),
    fork(cpAppEvalSKUsPostSaga),
    fork(networkCustomerCertificatesGetSaga),
    fork(updatableObjectsSaga),
    fork(ipsecVendorsGetSaga),
    fork(permissionCategoriesGetSaga),
    fork(servicesGetSaga),
    fork(regionsGetSaga),
    fork(membersAllGetSaga),
    fork(groupsGetSaga),
    fork(webCategoriesGetSaga),
    fork(addressesGetSaga),
  ]);
}
